import React from 'react'
import { compose, withHandlers } from 'recompose'
import _ from 'lodash'
import { toast } from 'react-toastify'
import { withFormik } from 'formik'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import withBulmaModalLayout from '../../../modules/modal/withBulmalModalLayout'
import withLanguage from '../lang-select/withLanguage'
import config from '../../../config'
import Field from '../../views/widgets/Field'
import InputText from '../../views/widgets/InputText'
import BannerImage from './BannerImage'
import { createBanner } from '../../../modules/portal-remote/portalService'
import {
  UPDATE_BANNER_ITEM,
  CREATE_BANNER_ITEM,
} from '../../../constants/actions'
import { initBanner } from '../../../reducers/banners'
import { updateBanner } from '../../../actions/banners'
import { updateBanner as updateBannerRemote } from '../../../modules/portal-remote/portalService'

const BannerItemModal = ({
  language,
  onRequestClose,
  handleSubmit,
  handleChange,
  handleBlur,
  values,
  errors,
}) => {
  return (
    <div className="card">
      <header className="card-header">
        <p className="card-header-title">
          {values._id === initBanner._id ? 'Create Banner' : 'Edit Banner'}
        </p>
        <a className="card-header-icon" aria-label="more options">
          <span className="icon">
            <i className="fas fa-angle-down" aria-hidden="true" />
          </span>
        </a>
      </header>
      <div className="card-content">
        <div className="content">
          <Field label={`Image`}>
            <BannerImage
              bannerID={values._id}
              mainImageId={values.mainImageId}
              mainImageLastChecked={values.mainImageLastChecked}
            />
          </Field>
          <Field label={`Title[${_.toUpper(language)}]`}>
            <InputText
              name={`title.${language}`}
              placeholder="Enter your title"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.title[language]}
              error={errors.title && errors.title[language]}
            />
          </Field>
        </div>
      </div>
      <footer className="card-footer">
        <a
          className="card-footer-item button is-white"
          onClick={onRequestClose}
        >
          กลับ
        </a>
        <a
          className="card-footer-item button is-primary"
          onClick={handleSubmit}
        >
          บันทึก
        </a>
      </footer>
    </div>
  )
}

export default compose(
  withLanguage,
  connect(
    null,
    dispatch => ({
      actions: bindActionCreators({ updateBanner: updateBanner }, dispatch),
    }),
  ),
  withHandlers({
    updateBanner: props => {
      return _.debounce(props.actions.updateBanner, 1000)
    },
  }),
  withFormik({
    mapPropsToValues: ({ params: { banner } }) => {
      return {
        title: config.getLangText(),
        ...banner,
      }
    },
    handleSubmit: async (values, { props }) => {
      try {
        let action = null
        if (values._id !== initBanner._id) {
          await updateBannerRemote(values)
          toast.success(
            `Update ${_.get(values, `title.${props.language}`)} success`,
          )
          action = UPDATE_BANNER_ITEM
        } else {
          values = await createBanner(values)
          toast.success(
            `Create ${_.get(values, `title.${props.language}`)} success`,
          )
          action = CREATE_BANNER_ITEM
        }

        if (props.onRequestClose) {
          props.onRequestClose({ action, values })
        }
      } catch (error) {
        toast.error(error.message)
      }
    },
    validate: (values, props) => {
      props.updateBanner(values)
      const errors = {}
      return errors
    },
    enableReinitialize: true,
    displayName: 'BannerForm',
  }),
  withBulmaModalLayout,
)(BannerItemModal)



// WEBPACK FOOTER //
// ./src/components/templates/banner-item/BannerItemModal.js